export const parseBooleanQueryValue = (value: string | null): boolean | undefined => {
  if (!value) {
    return undefined;
  }

  const normalized = value.toLowerCase();

  if (normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on') {
    return true;
  }

  if (normalized === '0' || normalized === 'false' || normalized === 'no' || normalized === 'off') {
    return false;
  }

  return undefined;
};
